// eslint-disable-next-line
/* eslint-disable-line */
import React, { Component } from "react";
import { Col, Container, Row, Table, Button, } from 'reactstrap';
import { withRouter, } from "react-router-dom";
import Select from 'react-select'
import moment from 'moment'
import Lottie from 'lottie-react-web'
import animationData from "../../../lotties/33623-piggy-bank-loop.json";
import ItemsCarousel from 'react-items-carousel';
import ViewTableroProductos from "./ViewTableroProductos";
import ViewTableroProductosRT from "./ViewTableroProductosRT";
import ViewTableroProgreso from "./ViewTableroProgreso";
import InputRange from 'react-input-range';
import Modal from 'react-modal'


const customStyles = { content : {top: '55%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '90%',height: '90%',} };

class TableroMainPage extends Component {
  constructor(props) {
    super(props);
    this.__getProgreso = this.__getProgreso.bind(this)
    this.state = {
      __getProgreso: this.__getProgreso,
      isLoading: true,
      date: moment().format('YYYY-MM-DD'),
      // date: '2022-10-24',
      arrClientes: [],
      infoModal: { title: '', data: [], }


    }
  }

  __getProgreso() {
    this.getProgresoByDay()
  }

  getProgresoByDay() {
    const { date, } = this.state
    const data = { date, }
    this.setState({ isLoading: false, })

    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getMovimientosCajerosByDay", this.headersPOST({ ...data, }))
    .then(response => response.json())
    .then((response) => {
      this.setState({ arrClientes: response, })
    })
  }

  openModalByType( type, item ) {
    let infoModal = {
      title: type.toUpperCase(),
      data: {},
    }


    this.setState({
      isOpenModal: true,
      infoModal,
    })


    if(type === 'ventas') {
      setTimeout(() => {
        const { date, } = this.state
        const data = { date, id_usuario: item.id_usuario }
        fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getMovimientosVentasByDate", this.headersPOST({ ...data, }))
        .then(response => response.json())
        .then((response) => {
          infoModal.data = response
          this.setState({ infoModal, })
        })
      }, 1000)
    } else if(type === 'cortes') {
      infoModal.data = item.cortes
      this.setState({ infoModal, })
    } else if(type === 'mermas') {
      infoModal.data = item.mermas
      this.setState({ infoModal, })
    } else if(type === 'traspasos') {
      infoModal.data = item.traspasos
      this.setState({ infoModal, })
    } else if(type === 'devoluciones') {
      infoModal.data = item.devoluciones
      this.setState({ infoModal, })
    }


  }

  componentDidMount() {
    this.getProgresoByDay()
    this.props.onRef(this)
  }

  render() {
    const { isLoading, arrClientes, date, infoModal, } = this.state
    const { signedIn, } = this.props.initState

    if(isLoading && signedIn.id_usuario !== 'wiwi00_adm') {
      return (
        <div className="directorPage__wrapper" style={{ marginTop: 150, }}>
          <Lottie
            direction={1}
            options={{
              animationData: animationData,
              loop: true,
            }}
          />
        </div>
      )
    }

    return (
      <div className="directorPage__wrapper"  style={{ paddingTop: 20, paddingBottom: 20, }}>
        <p className="regVentaPage__productGeneral" style={{ padding: 0, margin: 0, }}>VISTA PROGRESO DEL DÍA POR CAJERO</p>
        
        <Row>
          <Col>
            <p style={{ margin: 0, }}>Fecha</p>
            <input type={"date"}
              value={date}
              onChange={(event) => {
                this.setState({ date: event.target.value });
              }}
              style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: 0, width: '100%', }}
            />
            <button onClick={() => { this.getProgresoByDay() }} style={{ margin: 0, marginTop: 5, border: 0, background: 'rgb(183, 21, 64)', color:'#fff' }}>Generar</button>
          </Col>
        </Row>

        <div className="table-responsive">
          <Table className="table table-sm table-striped mt-2">
            <thead>
              <tr>
                <th>Cajero</th>
                <th style={{ textAlign: 'center', }}>Ventas</th>
                <th style={{ textAlign: 'center', }}>Cortes</th>
                <th style={{ textAlign: 'center', }}>Mermas</th>
                <th style={{ textAlign: 'center', }}>Devoluciones</th>
                <th style={{ textAlign: 'center', }}>Traspasos</th>
              </tr>
            </thead>
            <tbody>
            {
              arrClientes.length > 0 && arrClientes.map((t,e) => (
                <tr>
                  <th>
                    <p style={{ margin: 0, }}>{t.nombre}</p>
                    <p style={{ margin: 0, fontSize: '.6rem', color: '#777', fontWeight: 300, }}>{t.sucursal}</p>
                  </th>
                  <th onClick={() => { this.openModalByType('ventas', t) }} style={{ textAlign: 'center', }}>{Object.keys(t.ventas).length}</th>
                  <th onClick={() => { this.openModalByType('cortes', t) }} style={{ textAlign: 'center', }}>{t.cortes.length}</th>
                  <th onClick={() => { this.openModalByType('mermas', t) }} style={{ textAlign: 'center', }}>{Object.keys(t.mermas).length}</th>
                  <th onClick={() => { this.openModalByType('devoluciones', t) }} style={{ textAlign: 'center', }}>{Object.keys(t.devoluciones).length}</th>
                  <th onClick={() => { this.openModalByType('traspasos', t) }} style={{ textAlign: 'center', }}>{Object.keys(t.traspasos).length}</th>
                </tr>
              ))
            }
            </tbody>
          </Table>
        </div>


        <Modal
          overlayClassName="Overlay__aplicaciones"
          isOpen={this.state.isOpenModal}
          onRequestClose={() => { this.setState({ isOpenModal: false}) }}
          style={customStyles}
          contentLabel=""
          >
          <div className="">
            <Row className=""> 
              <Col>
                <h4 style={{ textAlign: 'center', }}>{infoModal.title}</h4>

                {
                  infoModal.title === 'VENTAS' && Object.keys( infoModal.data ).length ? (
                    <> 
                      {
                        Object.keys(infoModal.data).map((t0,e0) => (
                          <>
                            <Row>
                              <Col>
                                <p style={{ textAlign: 'left', fontWeight: 'bold', }}>Venta { moment(infoModal.data[t0][0].fecha_venta).format('HH:mm') }</p>
                              </Col>
                              <Col>
                                <Button style={{ textAlign: 'right', fontWeight: '300', }}>Devolución</Button>
                                </Col>
                              <Col>
                                <Button style={{ textAlign: 'right', fontWeight: '300', }}>Eliminar venta</Button>
                              </Col>
                            </Row>
                            <hr />
                            {
                              <div className="table-responsive">
                                <Table className="table table-sm table-striped mt-2">
                                  <thead>
                                    <tr>
                                      <td>Producto</td>
                                      <td>Precio compra</td>
                                      <td>Precio venta</td>
                                      <td>KG</td>
                                    </tr>
                                  </thead>

                                  <tbody>
                                  {
                                    infoModal.data[t0].map((t1,e1) => (
                                      <tr>
                                        <td>{t1.producto}</td>
                                        <td>{t1.venta_pcompra}</td>
                                        <td>{t1.venta_pesos}</td>
                                        <td>{t1.venta_kg}</td>
                                      </tr>
                                    ))
                                  }
                                  </tbody>
                                </Table>
                              </div>
                            }
                          </>
                        ))
                      }

                    </>
                  ) : null
                }

                {
                  infoModal.title === 'CORTES' && infoModal.data.length >0 ? (
                    <>
                      {
                        <div className="table-responsive">
                          <Table className="table table-sm table-striped mt-2">
                            <thead>
                              <tr>
                                <td>Observación</td>
                                <td>Monto</td>
                                <td>Fecha</td>
                                <td>Opciones</td>
                              </tr>
                            </thead>

                            <tbody>
                            {
                              infoModal.data.map((t1,e1) => (
                                <tr>
                                  <td>{
                                    t1.observacion === '' && t1.valor < 0 ? 'Apertura del día' : t1.observacion
                                  }</td>
                                  <td>${this.number_format(t1.valor,2)}</td>
                                  <td>{moment(t1.created_at).format('HH:mm')}</td>
                                  <td>Eliminar</td>
                                </tr>
                              ))
                            }
                            </tbody>
                          </Table>
                        </div>
                      }
                    </>
                  ) : null
                }

                {
                  infoModal.title === 'MERMAS' && Object.keys( infoModal.data ).length ? (
                    <> 
                      {
                        Object.keys(infoModal.data).map((t0,e0) => (
                          <>
                            <Row>
                              <Col>
                                <p style={{ textAlign: 'left', fontWeight: 'bold', }}>Venta { moment(infoModal.data[t0][0].fecha_venta).format('HH:mm') }</p>
                              </Col>
                              <Col>
                                <Button style={{ textAlign: 'right', fontWeight: '300', }}>Devolución</Button>
                                </Col>
                              <Col>
                                <Button style={{ textAlign: 'right', fontWeight: '300', }}>Eliminar venta</Button>
                              </Col>
                            </Row>
                            <hr />
                            {
                              <div className="table-responsive">
                                <Table className="table table-sm table-striped mt-2">
                                  <thead>
                                    <tr>
                                      <td>Producto</td>
                                      <td>Precio compra</td>
                                      <td>Precio venta</td>
                                      <td>KG</td>
                                    </tr>
                                  </thead>

                                  <tbody>
                                  {
                                    infoModal.data[t0].map((t1,e1) => (
                                      <tr>
                                        <td>{t1.producto}</td>
                                        <td>{t1.venta_pcompra}</td>
                                        <td>{t1.venta_pesos}</td>
                                        <td>{t1.venta_kg}</td>
                                      </tr>
                                    ))
                                  }
                                  </tbody>
                                </Table>
                              </div>
                            }
                          </>
                        ))
                      }

                    </>
                  ) : null
                }

                {
                  infoModal.title === 'DEVOLUCIONES' && Object.keys( infoModal.data ).length ? (
                    <> 
                      {
                        Object.keys(infoModal.data).map((t0,e0) => (
                          <>
                            <Row>
                              <Col>
                                <p style={{ textAlign: 'left', fontWeight: 'bold', }}>Venta { moment(infoModal.data[t0][0].fecha_venta).format('HH:mm') }</p>
                              </Col>
                              <Col>
                                <Button style={{ textAlign: 'right', fontWeight: '300', }}>Devolución</Button>
                                </Col>
                              <Col>
                                <Button style={{ textAlign: 'right', fontWeight: '300', }}>Eliminar venta</Button>
                              </Col>
                            </Row>
                            <hr />
                            {
                              <div className="table-responsive">
                                <Table className="table table-sm table-striped mt-2">
                                  <thead>
                                    <tr>
                                      <td>Producto</td>
                                      <td>Precio compra</td>
                                      <td>Precio venta</td>
                                      <td>KG</td>
                                    </tr>
                                  </thead>

                                  <tbody>
                                  {
                                    infoModal.data[t0].map((t1,e1) => (
                                      <tr>
                                        <td>{t1.producto}</td>
                                        <td>{t1.venta_pcompra}</td>
                                        <td>{t1.venta_pesos}</td>
                                        <td>{t1.venta_kg}</td>
                                      </tr>
                                    ))
                                  }
                                  </tbody>
                                </Table>
                              </div>
                            }
                          </>
                        ))
                      }

                    </>
                  ) : null
                }

                {
                  infoModal.title === 'TRASPASOS' && Object.keys( infoModal.data ).length ? (
                    <> 
                      {
                        Object.keys(infoModal.data).map((t0,e0) => (
                          <>
                            <Row>
                              <Col>
                                <p style={{ textAlign: 'left', fontWeight: 'bold', }}>Venta { moment(infoModal.data[t0][0].fecha_venta).format('HH:mm') }</p>
                              </Col>
                              <Col>
                                <Button style={{ textAlign: 'right', fontWeight: '300', }}>Devolución</Button>
                                </Col>
                              <Col>
                                <Button style={{ textAlign: 'right', fontWeight: '300', }}>Eliminar venta</Button>
                              </Col>
                            </Row>
                            <hr />
                            {
                              <div className="table-responsive">
                                <Table className="table table-sm table-striped mt-2">
                                  <thead>
                                    <tr>
                                      <td>Producto</td>
                                      <td>Precio compra</td>
                                      <td>Precio venta</td>
                                      <td>KG</td>
                                    </tr>
                                  </thead>

                                  <tbody>
                                  {
                                    infoModal.data[t0].map((t1,e1) => (
                                      <tr>
                                        <td>{t1.producto}</td>
                                        <td>{t1.venta_pcompra}</td>
                                        <td>{t1.venta_pesos}</td>
                                        <td>{t1.venta_kg}</td>
                                      </tr>
                                    ))
                                  }
                                  </tbody>
                                </Table>
                              </div>
                            }
                          </>
                        ))
                      }

                    </>
                  ) : null
                }

              </Col>
            </Row>
          </div>
        </Modal>

      </div>
    )

  }

  pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }

  uniqid() {
    var pr = '', en = false, result;this.seed = function (s, w) {s = parseInt(s, 10).toString(16);return w < s.length ? s.slice(s.length - w) : (w > s.length) ? new Array(1 + (w - s.length)).join('0') + s : s;};result = pr + this.seed(parseInt(new Date().getTime() / 1000, 10), 8) + this.seed(Math.floor(Math.random() * 0x75bcd15) + 1, 5);if (en) {result += (Math.random() * 10).toFixed(8).toString();} return result;
  }

  getStyleModal(opt) {
    if(opt === 'isOpenViewInfoCortes') {
      return { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '50%',height: '70%',} };
    }

    return { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '80%',height: '80%',} };
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return ''+(Math.round(n * k) / k)
      .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length+1).join('0')
    }
    return s.join(dec)
  }

  getColorByIndex(e) {
    const color = ['#F0F4FE','#A7CDF2','#E2EFE3','#8FAEE3','#F0F4FE','#A7CDF2','#E2EFE3','#8FAEE3']
    return color[e]
  }


  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

 getURLByOPT(opt) {
    let PHP = this.props.initState.debug === 1 ? 'controllerPreproduction.php' : 'controllerWebApp.php'
    return `https://hg.wsoft.com.mx/REST/controllers/${PHP}?opt=${opt}`
  }


}

export default withRouter(TableroMainPage)